document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initCountUp();
  initComparadorSlider();
  document.querySelectorAll('[data-mt-galeria]').forEach(initGaleriaProducto);
  document.querySelectorAll('[data-mt-producto-form]').forEach(initVariantSelector);
  document.querySelectorAll('[data-mt-cat-card]').forEach(initCatalogSwatches);
  initFaqAccordion();
});

function initReveal() {
  var items = document.querySelectorAll('.mt-reveal');
  if (!items.length) return;
  if (!('IntersectionObserver' in window)) {
    items.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );
  items.forEach(function (el, i) {
    el.style.setProperty('--mt-stagger', i % 8);
    observer.observe(el);
  });
}

function initCountUp() {
  var items = document.querySelectorAll('.mt-countup');
  if (!items.length || !('IntersectionObserver' in window)) return;
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        observer.unobserve(el);
        var target = parseFloat(el.getAttribute('data-target') || '0');
        var suffix = el.getAttribute('data-suffix') || '';
        var duration = 1200;
        var start = null;
        function step(ts) {
          if (!start) start = ts;
          var progress = Math.min((ts - start) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          var value = target * eased;
          el.textContent = (target % 1 === 0 ? Math.round(value) : value.toFixed(1)) + suffix;
          if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    },
    { threshold: 0.5 }
  );
  items.forEach(function (el) { observer.observe(el); });
}

function initComparadorSlider() {
  var wrap = document.querySelector('[data-mt-comparador]');
  if (!wrap) return;
  var handle = wrap.querySelector('[data-mt-comparador-handle]');
  var afterLayer = wrap.querySelector('[data-mt-comparador-after]');
  if (!handle || !afterLayer) return;

  function setPos(percent) {
    percent = Math.max(0, Math.min(100, percent));
    afterLayer.style.clipPath = 'inset(0 ' + (100 - percent) + '% 0 0)';
    handle.style.left = percent + '%';
  }

  function fromEvent(clientX) {
    var rect = wrap.getBoundingClientRect();
    var percent = ((clientX - rect.left) / rect.width) * 100;
    setPos(percent);
  }

  var dragging = false;
  handle.addEventListener('pointerdown', function () { dragging = true; });
  window.addEventListener('pointerup', function () { dragging = false; });
  window.addEventListener('pointermove', function (e) {
    if (!dragging) return;
    fromEvent(e.clientX);
  });
  wrap.addEventListener('click', function (e) {
    fromEvent(e.clientX);
  });
  setPos(50);
}

function initGaleriaProducto(galeria) {
  var main = galeria.querySelector('[data-mt-galeria-principal]');
  var video = galeria.querySelector('[data-mt-galeria-video]');
  var thumbs = galeria.querySelectorAll('[data-mt-galeria-thumb]');
  if (!main || !thumbs.length) return;

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      selectThumb(thumb);
    });
  });

  function selectThumb(thumb) {
    var type = thumb.getAttribute('data-mt-type') || 'image';
    if (type === 'video' && video) {
      var videoSrc = thumb.getAttribute('data-video-src');
      var poster = thumb.getAttribute('data-poster');
      if (video.src !== videoSrc) video.src = videoSrc;
      if (poster) video.poster = poster;
      main.style.display = 'none';
      video.style.display = 'block';
    } else {
      if (video) {
        video.pause();
        video.style.display = 'none';
      }
      var src = thumb.getAttribute('data-full');
      var alt = thumb.getAttribute('data-alt') || '';
      main.src = src;
      main.alt = alt;
      main.style.display = 'block';
    }
    thumbs.forEach(function (t) { t.classList.remove('mt-thumb-active'); });
    thumb.classList.add('mt-thumb-active');
  }

  galeria.filterByScope = function (selectedValue) {
    var matchingThumb = null;
    var firstVisible = null;
    thumbs.forEach(function (thumb) {
      var scope = thumb.getAttribute('data-mt-scope') || 'all';
      var visible = scope === 'all' || scope === selectedValue;
      thumb.style.display = visible ? '' : 'none';
      if (visible && !firstVisible) firstVisible = thumb;
      if (scope === selectedValue) matchingThumb = thumb;
    });
    // Prioriza SIEMPRE la foto específica de la variante elegida; si no hay
    // una foto propia para esa variante, usa la primera genérica visible.
    var target = matchingThumb || firstVisible;
    if (target) selectThumb(target);
  };
}

function initVariantSelector(form) {
  var container = form.closest('.mt-section') || form.parentElement;
  var optionEls = form.querySelectorAll('[data-mt-variant-option]');
  var variantsScript = form.parentElement.querySelector('[data-mt-variants-json]') || container.querySelector('[data-mt-variants-json]');
  var idInput = form.querySelector('input[name="id"]');
  var priceEl = container.querySelector('[data-mt-precio]');
  var compareEl = container.querySelector('[data-mt-precio-comparado]');
  var addBtn = form.querySelector('[data-mt-add-btn]');
  var galeria = container.querySelector('[data-mt-galeria]');
  if (!optionEls.length || !variantsScript || !idInput) return;

  var variants = JSON.parse(variantsScript.textContent);

  // Soporta tanto <select> (repuestos) como tarjetas de radio (packs del
  // producto principal): agrupa por "name" y toma el valor activo de cada
  // grupo, en el orden en que aparece por primera vez en el formulario.
  function currentSelection() {
    var order = [];
    var values = {};
    optionEls.forEach(function (el) {
      var key = el.name || 'opt';
      if (order.indexOf(key) === -1) order.push(key);
      if (el.tagName === 'SELECT') {
        values[key] = el.value;
      } else if (el.checked) {
        values[key] = el.value;
      }
    });
    return order.map(function (key) { return values[key]; });
  }

  function findVariant() {
    var values = currentSelection();
    return variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === values[i]; });
    });
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function updateUI() {
    var variant = findVariant();
    if (!variant) return;
    idInput.value = variant.id;
    if (priceEl) priceEl.textContent = money(variant.price);
    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = money(variant.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
    if (addBtn) {
      if (variant.available) {
        addBtn.disabled = false;
        addBtn.textContent = addBtn.getAttribute('data-label-available') || 'Add to Cart';
      } else {
        addBtn.disabled = true;
        addBtn.textContent = addBtn.getAttribute('data-label-sold-out') || 'Sold Out';
      }
    }
    if (galeria && galeria.filterByScope) {
      galeria.filterByScope(currentSelection()[0]);
    }

    var imageMapScript = container.querySelector('[data-mt-refill-images]');
    var refillImage = container.querySelector('[data-mt-refill-image]');
    if (imageMapScript && refillImage) {
      var imageMap = JSON.parse(imageMapScript.textContent);
      var url = imageMap[currentSelection()[0]];
      if (url) refillImage.src = url;
    }
  }

  function updatePackCardStyles() {
    optionEls.forEach(function (el) {
      if (el.tagName !== 'INPUT' || el.type !== 'radio') return;
      var card = el.closest('[data-mt-pack-card]');
      if (!card) return;
      card.classList.toggle('mt-pack-card--active', el.checked);
      // Estilo en línea directo: garantiza el color sin depender de que la
      // hoja de estilos externa gane la cascada frente al borde en línea.
      if (el.checked) {
        card.style.setProperty('border-color', 'var(--mt-color-accent-strong)', 'important');
        card.style.setProperty('background', 'var(--mt-color-bg-pink)', 'important');
      } else {
        card.style.setProperty('border-color', '#E7EAF0');
        card.style.setProperty('background', '#FFFFFF');
      }
    });
  }

  updatePackCardStyles();
  optionEls.forEach(function (el) {
    el.addEventListener('change', function () {
      updatePackCardStyles();
      updateUI();
    });
  });
  updateUI();
}

function initCatalogSwatches(card) {
  var main = card.querySelector('[data-mt-cat-main]');
  var swatches = card.querySelectorAll('[data-mt-cat-swatch]');
  if (!main || !swatches.length) return;

  swatches.forEach(function (swatch) {
    swatch.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var src = swatch.getAttribute('data-full');
      if (src) {
        main.src = src;
        // Las fotos de variante son flyers con texto: nunca recortarlas.
        main.style.objectFit = 'contain';
        main.style.objectPosition = 'center center';
      }
      swatches.forEach(function (s) { s.classList.remove('mt-swatch-active'); });
      swatch.classList.add('mt-swatch-active');
    });
  });
}

function initFaqAccordion() {
  var items = document.querySelectorAll('[data-mt-faq-item]');
  if (!items.length) return;
  items.forEach(function (item) {
    var btn = item.querySelector('[data-mt-faq-toggle]');
    var panel = item.querySelector('[data-mt-faq-panel]');
    if (!btn || !panel) return;
    btn.addEventListener('click', function () {
      var isOpen = item.classList.contains('mt-faq-open');
      items.forEach(function (i) { i.classList.remove('mt-faq-open'); });
      if (!isOpen) item.classList.add('mt-faq-open');
    });
  });
}
